import { render, staticRenderFns } from "./chargebee-addons-manager.vue?vue&type=template&id=639d73bf"
import script from "./chargebee-addons-manager.vue?vue&type=script&lang=js"
export * from "./chargebee-addons-manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports